


import TiwiMixin from '../mixins/TiwiMixin'

import Splide from '@splidejs/splide';

export default {
  mixins: [TiwiMixin],
 
  props: {
    slides: {
      type: Array,
      required: true
    }   
  },
  data() {
    return {
     
    }
  },
  mounted: function () {
    

  },
 
  methods: {

  }
}
